// import 'bootstrap/dist/css/bootstrap.min.css';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import './Navbar.css'
import "../fonts/fonts.css"
import logo from "../images/BB_Crni.png"
import {getTotalQuantity} from "../reducers/cart";
import {connect} from "react-redux";
import { logout} from "../actions";

import React, {useEffect, useState} from 'react';
import './Navbar.css';


function Navbar({ cartItemCount }) {
    let navigate = useNavigate();
    const isAuthenticated = localStorage.getItem("auth") === "true"
    const location = useLocation();


    const [scrolled, setScrolled] = useState(false);
    const [navbarOpen, setNavbarOpen] = useState(false);
    // const [dropdownOpen, setDropdownOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [navbarColor, setNavbarColor] = useState(location.pathname.startsWith('/home'));
    const [showBanner, setShowBanner] = useState(location.pathname.startsWith('/shop') || location.pathname.startsWith('/cart'));
    const [showLogo, setShowLogo] = useState(false);


    useEffect(() => {
        if (!navbarOpen) {
            const timeout = setTimeout(() => {
                setShowLogo(true);
            }, 500); // Adjust this timeout based on your animation duration

            return () => clearTimeout(timeout);
        } else {
            setShowLogo(false);
        }
    }, [navbarOpen]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const [bannerTextIndex, setBannerTextIndex] = useState(0);
    const bannerTexts = [
        'Besplatna dostava za narudžbe unutar Zagreba',
        'Besplatna dostava iznad 70€ za sve narudžbe',
        'Narudžbe zaprimljene do 15 sati bit će poslane istog dana',
        // Dodajte više tekstova za banner po potrebi
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setBannerTextIndex((prevIndex) => (prevIndex + 1) % bannerTexts.length);
        }, 5000); // Change text every 5 seconds (5000 milliseconds)

        return () => clearInterval(interval);
    }, [bannerTexts.length]);

    useEffect(() => {
        setShowBanner(location.pathname.startsWith('/') || location.pathname.startsWith('/cart'));
    }, [location.pathname]);

    useEffect(() => {
        setNavbarColor(location.pathname.startsWith('/home'));
    }, [location.pathname]);

    const handleToggle = () => {
        setNavbarOpen(!navbarOpen);
    };

    const handleScroll = () => {
        if (window.scrollY > 200) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleLogout = () => {
        logout();
        localStorage.removeItem("jwtToken")
        localStorage.removeItem("auth")
        navigate('/home', { replace: true }); // Navigate to the home page after logout
        window.location.reload(); // Refresh the page
    };

    const handleNavLinkClick = () => {
        const btn2 = document.getElementById('navbar-toggler');
        btn2.click();
        }



    return (
        <>
            {showBanner &&
                <div className="top-banner" style={{backgroundColor: "grey"}}>
                    <div className="container-banner">
                        <div className="banner-text">{bannerTexts[bannerTextIndex]}</div>
                    </div>
                </div>
            }
            <div className={`navbar${scrolled ? ' scrolled' : ''}`} id="navbar"  style={{ zIndex: "100", marginTop: showBanner ? '1.8rem' : '', backgroundColor: navbarColor || scrolled ? "white": "" }}>
                {/*{navbarOpen && <div className="navbar-bg-big" style={{ marginTop: showBanner ? '3rem' : ''}}></div>}*/}
                {/*{navbarOpen && !(window.location.pathname === "/" && !scrolled) && (*/}
                {/*    <div className="navbar-bg-big" style={{ marginTop: showBanner ? '3rem' : ''}}></div>*/}
                {/*)}*/}
                {navbarOpen && (
                    <div className="navbar-bg-big" style={{ marginTop: showBanner ? '3rem' : ''}}></div>
                )}
                <nav className={`navbar-bg${scrolled ? ' scrolled' : ''} navbar-expand-lg navbar-light font-pro grandparent`} >
                    <Link className="nav-link" id="nav-link" to="/home" onClick={handleNavLinkClick}>
                    {(showLogo || windowWidth > 991) && (
                        <div className="logo-div">
                            <img src={logo} className="logo-img" alt="Logo" />
                        </div>
                    )}
                    </Link>
                    <button className="navbar-toggler" type="button" id="navbar-toggler" onClick={handleToggle} data-toggle="collapse" data-target="#collapsibleNavbar">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse justify-content-center centered parent font-navbar" id="collapsibleNavbar">
                        <ul className="navbar-nav center">
                            {/*<Link className="nav-link" id="nav-link" to="/" onClick={handleNavLinkClick}>*/}
                            {/*{(showLogo || windowWidth > 991) && (*/}
                            {/*    <div className="logo-div">*/}
                            {/*        <img src={logo} className="logo-img" alt="Logo" />*/}
                            {/*    </div>*/}
                            {/*)}*/}
                            {/*</Link>*/}

                            <li className="nav-item active nav-item-not-dropdown">
                                <Link className="nav-link" id="nav-link" to="/home" onClick={handleNavLinkClick}>Početna <span className="sr-only"></span></Link>
                            </li>
                            {/*<li className="nav-item nav-item-not-dropdown">*/}
                            {/*    <Link className="nav-link" id="nav-link" to="/tretmani" onClick={handleNavLinkClick}>Tretmani</Link>*/}
                            {/*</li>*/}
                            {/*<li className="nav-item nav-item-not-dropdown">*/}
                            {/*    <Link className="nav-link" id="nav-link" to="/tretmani/cjenik" onClick={handleNavLinkClick}>Cjenik</Link>*/}
                            {/*</li>*/}
                            {/*<li className="nav-item nav-item-not-dropdown">*/}
                            {/*    <Link className="nav-link" id="nav-link" to="/shop" onClick={handleNavLinkClick}>Shop</Link>*/}
                            {/*</li>*/}
                            {/*<li className="nav-item dropdown">*/}
                            {/*    <span className="nav-link" id="nav-link" role="button" data-bs-toggle="dropdown" aria-expanded="false">*/}
                            {/*        Shop*/}
                            {/*    </span>*/}
                            {/*    <ul className="dropdown-menu">*/}
                            {/*        <li>*/}
                            {/*            <Link className="dropdown-item" to="/shop/brands/InLei" onClick={handleNavLinkClick}>InLei</Link>*/}
                            {/*        </li>*/}
                            {/*        <li>*/}
                            {/*            <Link className="dropdown-item" to="/shop/brands/skinderma" onClick={handleNavLinkClick}>SKINDERMA</Link>*/}
                            {/*        </li>*/}
                            {/*    </ul>*/}
                            {/*</li>*/}
                            <li className="nav-item nav-item-not-dropdown">
                                <Link className="nav-link" id="nav-link" to="/shop/brands/InLei" onClick={handleNavLinkClick}>InLei</Link>
                            </li>
                            <li className="nav-item nav-item-not-dropdown">
                                <Link className="nav-link" id="nav-link" to="/shop/brands/skinderma" onClick={handleNavLinkClick}>SKINDERMA</Link>
                            </li>

                            {isAuthenticated &&
                                <li className="nav-item nav-item-not-dropdown">
                                    <Link className="nav-link" id="nav-link" to="/narudzbe"  onClick={handleNavLinkClick}>Narudžbe</Link>
                                </li>
                            }
                            {isAuthenticated &&
                                <li className="nav-item nav-item-not-dropdown">
                                    <Link className="nav-link" id="nav-link" to="/admin/discounts"  onClick={handleNavLinkClick}>Kodovi</Link>
                                </li>
                            }
                            <li className="nav-item nav-item-not-dropdown">
                                <Link className="nav-link" id="nav-link"  to="/kontakt" onClick={handleNavLinkClick}>Kontakt</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="navbar-text order-lg-last right-content">
                        <div style={{ display: "flex", alignItems: "center"}} className="d-lg-flex košarica">

                            <Link className="nav-link right-content right" id="nav-link" to="/cart" style={{padding: "5px"}}>Košarica</Link>
                            <span id="nav-link">{"(" + cartItemCount + ")"}</span>
                            {isAuthenticated && (
                                <button className=" btn-link nav-link" id="nav-link" onClick={handleLogout} style={{ marginLeft: "1em" }}>
                                    Logout
                                </button>
                            )}
                        </div>
                    </div>
                </nav>
            </div>
        </>
        );
    }


const mapStateToProps = state => {
    const cartItemCount = getTotalQuantity(state, /* productId */);
    return {
        cartItemCount,
    };
};

const mapDispatchToProps = {
    logout
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Navbar);
